<div *ngIf="templatePriority">
    <div class="d-flex mt-3">
        <span class="content-switcher-title">{{templatePriority.template_display_label}}</span>
        <span
            *ngIf="templatePriorityService.getTemplatesWithByEventTypesEnabled().includes(templatePriority.template_name)">
            <dsy-icon library="system" name="information" size="16px"></dsy-icon>
            <dsy-tooltip [isParentHoverable]="true" [isVisible]="isIconVisible"
                [customComponentStyle]="'top: unset; left: unset;background: #F7F8FB; color: #313B49; height: 86px; width: 220px;'"
                [customSlotContainerStyle]="'font-size: 12px'" [hoverableElement]="iconInfo"
                preToggleVisibility="isIconVisible = !isIconVisible">
                If the priority selection for the main template is disabled, clear up the priorities based
                on
                Event Type.
            </dsy-tooltip>
        </span>
    </div>
    <div class="row">
        <dsy-content-switcher class="col-3" [contentList]="templatePriorityWithSwitcher.switcher"
            [functionSetterData]="switcherComponent" [setIndexContentChosed]="setIndexContentChosed"
            [indexContentChosed]="switcherComponentValueIndex"
            [ngClass]="(!editEnabled || templatePriority.customizations?.length > 0) ? 'content-switcher-no-edit' : 'content-switcher-edit'"
            (click)="setSwitcherValue($event)">
        </dsy-content-switcher>
        <div class="d-flex col-9" *ngIf="editEnabled && templatePriority.customizations?.length > 0 && switcherComponentValueIndex == 3">
            <span class="justify-content-end fs-5 edit-button cursor-pointer" (click)="handleEdit()">EDIT</span>
        </div>
    </div>
    <div class="row chip-container chip-container-grey" *ngIf="templatePriority?.customizations?.length > 0">
        <dsy-card card-color="#1F6CF9" height="25px" round-border="true" no-padding="true"
            class="justify-content-start col-3 chip"
            [ngClass]="!showMore && customPriorityIndex >= lengthByScreen ? 'not-show-more' : 'show-more'"
            *ngFor="let customPriority of templatePriority.customizations; let customPriorityIndex = index">
            <span class="px-2 chip-text"><span class="bold">{{customPriority.event_type}}</span>:
                {{customPriority.priority}}</span>
        </dsy-card>
        <div *ngIf="templatePriority?.customizations?.length > lengthByScreen"
            style="width: 50px; padding: 10px 10px;">
            <dsy-card card-color="#F4F8FF" height="30px" round-border="true" no-padding="true" active-border>
                <div class="d-flex justify-content-center cursor-pointer"
                    (click)="showMore = true" *ngIf="!showMore">
                    <dsy-icon name="add" library="system" size="10px" class="mt-2"></dsy-icon>
                    {{templatePriority?.customizations?.length - lengthByScreen}}
                </div>
                <div class="d-flex justify-content-center cursor-pointer" *ngIf="showMore">
                    <button (click)="showMore = false" class="btn btn-link">
                        <dsy-icon library="system" name="arrow-up" size="16px"></dsy-icon>
                    </button>
                </div>
            </dsy-card>
        </div>
    </div>
</div>

<app-sidebar *ngIf="openSidebar" [templatePriority]="templatePriority" [eventTypes]="eventTypes"
    [dropdownSelectedEntries]="dropdownSelectedEntries" (close)="closeSidebar($event)"></app-sidebar>